import { createApp } from 'vue';
import App from './view/App';
import router from './router';
import store from './store';
// import setupInterceptors from './services/setupInterceptors';

// setupInterceptors(store);

//Bootstrap
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery';

// Mosha Toast
import moshaToast from 'mosha-vue-toastify';
import 'mosha-vue-toastify/dist/style.css';
import VueSweetalert2 from 'vue-sweetalert2';

//Custom CSS
import './assets/css/main.css';
import 'sweetalert2/dist/sweetalert2.min.css';

//FontAwesome
import { FontAwesomeIcon } from './plugins/font-awesome';



createApp(App)
  .use(router)
  .use(store)
  .use(moshaToast)
  .use(VueSweetalert2)
  .component('font-awesome-icon', FontAwesomeIcon)
  .mount('#app');
